// extracted by mini-css-extract-plugin
export var deliveryRow = "_t9-a";
export var fixedHeight = "_t9-4";
export var freightLogo = "_t9-9";
export var fullWidth = "_t9-3";
export var priceColumn = "_t9-5";
export var radioSelected = "_t9-7";
export var radioUnselected = "_t9-6";
export var selectedOption = "_t9-2";
export var selectedOptionContainer = "_t9-1";
export var selection = "_t9-0";
export var tallSkeletonText = "_t9-8";